import { ReactElement } from 'react';

const MediumIcon = (props: TClassNameProps): ReactElement => (
	<svg width="20" height="11.359" viewBox="0 0 20 11.359" {...props}>
		<g id="Group_364" data-name="Group 364" transform="translate(-1573.608 -1638.426)">
			<path
				id="Path_11651"
				data-name="Path 11651"
				d="M306.061,285.579a5.641,5.641,0,1,1-5.64-5.679,5.66,5.66,0,0,1,5.64,5.679"
				transform="translate(1278.828 1358.526)"
				fill="currentColor"
			/>
			<path
				id="Path_11652"
				data-name="Path 11652"
				d="M917.641,302.607c0,2.952-1.263,5.347-2.82,5.347s-2.82-2.394-2.82-5.347,1.262-5.347,2.82-5.347,2.82,2.394,2.82,5.347"
				transform="translate(673.437 1341.499)"
				fill="currentColor"
			/>
			<path
				id="Path_11653"
				data-name="Path 11653"
				d="M1236.884,331.11c0,2.645-.444,4.79-.992,4.79s-.992-2.145-.992-4.79.444-4.79.992-4.79.992,2.144.992,4.79"
				transform="translate(356.725 1312.996)"
				fill="currentColor"
			/>
		</g>
	</svg>
);

export default MediumIcon;
